import i18next from 'i18next';

import { HEADER_IDS } from './constants';

i18next.addResources('es', 'NoteTable', {
  [HEADER_IDS.DATE]: 'Fecha',
  [HEADER_IDS.INTERVENER]: 'Interviniente',
  [HEADER_IDS.DETAIL]: 'Descripción / Detalle'
});
